import { CHART_SERIES } from 'src/styles/chartTheme';

/**
 * Categorical series palette for charts rendered in the AI chat, one slot per
 * series in fixed order (never cycled). Both modes validated for lightness,
 * chroma, colour-vision-deficiency separation and contrast against the
 * elevated surface of the respective theme.
 */
export const SERIES_LIGHT = CHART_SERIES.light;
export const SERIES_DARK = CHART_SERIES.dark;

export const SURFACE_LIGHT = '#FFFFFF';
export const SURFACE_DARK = '#1A1B22';

export const withAlpha = (hex: string, alpha: number): string => {
  const value = hex.replace('#', '');
  const r = parseInt(value.slice(0, 2), 16);
  const g = parseInt(value.slice(2, 4), 16);
  const b = parseInt(value.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
